"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import { shopifyOtherServices, ShopifyOtherService } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyOtherServicesProps {
  heading?: string;
  subtitle?: string;
  services?: ShopifyOtherService[];
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function ShopifyOtherServices(t0) {
  const $ = _c(37);
  const {
    heading: t1,
    subtitle: t2,
    services: t3,
    buttonText: t4,
    buttonHref: t5,
    className: t6
  } = t0;
  const heading = t1 === undefined ? "Are you Looking For Other Services?" : t1;
  const subtitle = t2 === undefined ? "Technology solutions to overcome the unique challenges and generate value for businesses in different industries." : t2;
  const services = t3 === undefined ? shopifyOtherServices : t3;
  const buttonText = t4 === undefined ? "View More Services" : t4;
  const buttonHref = t5 === undefined ? "/web-development" : t5;
  const className = t6 === undefined ? "" : t6;
  const desktopAnimations = useDesktopAnimations();
  const t7 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  let t9;
  if ($[1] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  let t11;
  if ($[5] !== desktopAnimations) {
    t11 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  let t13;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      once: true
    };
    t13 = {
      duration: 0.7,
      ease
    };
    $[7] = t12;
    $[8] = t13;
  } else {
    t12 = $[7];
    t13 = $[8];
  }
  let t14;
  if ($[9] !== heading) {
    t14 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== subtitle) {
    t15 = subtitle && <p className="font-sans mt-3 text-[14.5px] font-normal leading-[26px] text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[11] = subtitle;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t14 || $[16] !== t15 || $[17] !== t9) {
    t16 = <motion.div initial={t9} whileInView={t10} animate={t11} viewport={t12} transition={t13} className="mx-auto mb-12 max-w-3xl text-center md:mb-16">{t14}{t15}</motion.div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t14;
    $[16] = t15;
    $[17] = t9;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== desktopAnimations || $[20] !== services) {
    let t18;
    if ($[22] !== desktopAnimations) {
      t18 = (service, idx) => <motion.div key={service.id} initial={desktopAnimations ? {
        opacity: 0,
        y: 35
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: idx * 0.12,
        ease
      }} className="h-full"><article className="group relative flex h-full flex-col items-center justify-between overflow-hidden rounded-[20px] border border-[#e5f0f9] bg-white p-8 text-center shadow-[0_4px_24px_rgba(20,50,90,0.05)] transition-all duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:-translate-y-2.5 hover:border-transparent hover:bg-[linear-gradient(135deg,#ff1f71_0%,#d91b8a_50%,#b02cd6_100%)] hover:shadow-[0_20px_45px_rgba(235,32,130,0.35)] sm:p-9 md:p-10 dark:border-gray-800 dark:bg-gray-900"><div className="mb-6 flex h-16 w-16 items-center justify-center sm:h-20 sm:w-20"><Image src={service.icon} alt={service.alt} width={80} height={80} loading="lazy" className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-110" onError={_temp} /></div><h3 className="font-poppins mb-3 text-[20px] font-bold leading-tight text-[#0b1354] transition-colors duration-300 group-hover:text-white sm:text-[22px] dark:text-white">{service.title}</h3><p className="font-sans mb-6 text-[14px] leading-[25px] text-[#5e6282] transition-colors duration-300 group-hover:text-white/95 sm:text-[14.5px] dark:text-gray-300">{service.description}</p><Link href={service.linkHref} className="mt-auto inline-flex items-center gap-1.5 font-poppins text-[14px] font-semibold text-[#0b1354] transition-colors duration-300 group-hover:text-white dark:text-white"><span>{service.linkText}</span><FaChevronRight className="text-[10px] transition-transform duration-300 group-hover:translate-x-1" /></Link></article></motion.div>;
      $[22] = desktopAnimations;
      $[23] = t18;
    } else {
      t18 = $[23];
    }
    t17 = services.map(t18);
    $[19] = desktopAnimations;
    $[20] = services;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[24] !== t17) {
    t18 = <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">{t17}</div>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== buttonHref || $[27] !== buttonText || $[28] !== desktopAnimations) {
    t19 = buttonText && <motion.div initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: 0.25,
      ease
    }} className="mt-14 flex justify-center text-center md:mt-18"><GradientButton href={buttonHref} variant="pink-purple" className=""><span>{buttonText}</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></motion.div>;
    $[26] = buttonHref;
    $[27] = buttonText;
    $[28] = desktopAnimations;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t16 || $[31] !== t18 || $[32] !== t19) {
    t20 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t16}{t18}{t19}</div>;
    $[30] = t16;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t20 || $[35] !== t7) {
    t21 = <section className={t7}>{t8}{t20}</section>;
    $[34] = t20;
    $[35] = t7;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  return t21;
}
function _temp(e) {
  e.currentTarget.src = "/images/crm/why-1.png";
}